var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.embedUrl)?_c('iframe',{staticStyle:{"width":"100%"},attrs:{"src":_setup.embedUrl,"frameborder":"0","height":"1200","allowtransparency":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }